export default __webpack_public_path__ + "static/media/EZist_ARI-10.18ce9a49.png";